import { useState, memo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthenticationForms from "./AuthenticationForms";
import { setToLocal, successToaster } from "../../utils";
import { useForm } from "src/hooks/useForm";
import FieldInput from "src/component/FieldInput/FieldInput";
import SubmitBtn from "src/component/ActionBtn/SubmitBtn";
import { ForgetUserPassword } from "src/requests/user";

const default_cred = { phone: "" };

const ForgetPasswordC = () => {

  const { register, handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const navigate = useNavigate()

  const forgetPassword = (data: any) => {

    setLoading(true);
    ForgetUserPassword(data.phone.value)
      .then((result) => {
        setLoading(false);
        navigate('/reset-Password')
        setToLocal('phoneNumberforChange', data.phone.value)
        successToaster("Code is sent to your phoneNumber");
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <AuthenticationForms>
      <h1 className="login-content-header-title">{t("Send Code")}</h1>
      <div className="inputs-container">
        <FieldInput label="phone" isRequired {...register("phone")} defaultValue={default_cred?.phone} />
      </div>

      <SubmitBtn onSubmit={handleSubmit(forgetPassword)} loading={loading} label="Send Code" />

      <div className="clearfix"></div>

      <div className="separator"></div>

      <div className="loginRegisterQuestion">
        {t("backTo")}{" "}
        <Link to="/login" className="highlight">
          {t("login")}
        </Link>
      </div>
    </AuthenticationForms>
  );
};

export default memo(ForgetPasswordC);
